module.exports = __webpack_public_path__ + "static/media/col.ad9c5d61.svg";